var _g, _rect, _circle, _circle2, _circle3, _g2, _g3, _g4, _rect2, _rect3, _rect4, _rect5, _g5, _path, _path2, _path3, _path4, _path5, _g6, _path6, _g7, _path7, _g8, _rect6, _rect7, _g9, _path8, _g10, _g11, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCode2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 631,
    height: 405,
    viewBox: "0 0 631 405",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_7261)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 59,
    y: 38,
    width: 529,
    height: 317,
    rx: 25,
    fill: "#21214C",
    fillOpacity: 0.02
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 59,
    y: 38,
    width: 529,
    height: 317,
    rx: 25,
    fill: "url(#paint0_linear_1_7261)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 82.7088,
    cy: 60.7099,
    r: 6.7099,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 100.155,
    cy: 60.7099,
    r: 6.7099,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 117.6,
    cy: 60.7099,
    r: 6.7099,
    fill: "white"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1_7261)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 89.6909,
    width: 280.682,
    height: 62.6175,
    rx: 5.87116,
    fill: "url(#paint1_linear_1_7261)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_1_7261)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 74,
    y: 167,
    width: 280.682,
    height: 61.6967,
    rx: 5.87116,
    fill: "url(#paint2_linear_1_7261)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_1_7261)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 303,
    y: 177,
    width: 42.7756,
    height: 42.3814,
    rx: 6.7099,
    fill: "url(#paint3_linear_1_7261)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M316.385 200.163C315.133 198.972 313.227 198.972 311.975 200.163C310.702 201.374 310.702 203.248 311.975 204.459L316.512 208.775C317.112 209.346 317.78 209.669 318.717 209.669C319.654 209.669 320.322 209.346 320.922 208.775L336.801 193.667C338.073 192.456 338.073 190.583 336.801 189.372C335.549 188.18 333.643 188.18 332.391 189.372L318.717 202.382L316.385 200.163ZM333.008 190.009L318.717 203.606L315.768 200.8C314.861 199.937 313.5 199.937 312.592 200.8C312.272 201.105 312.065 201.463 311.971 201.837C312.065 201.463 312.272 201.105 312.592 200.8C313.5 199.937 314.861 199.937 315.768 200.8L318.717 203.606L333.008 190.009C333.915 189.146 335.276 189.146 336.184 190.009C336.771 190.568 336.978 191.308 336.805 191.994C336.978 191.308 336.771 190.568 336.184 190.009C335.276 189.145 333.915 189.145 333.008 190.009Z",
    fill: "white"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 84.0403,
    y: 103.998,
    width: 165.231,
    height: 14.1271,
    rx: 7.06356,
    fill: "white",
    fillOpacity: 0.4
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 108.638,
    y: 181.573,
    width: 165.231,
    height: 14.1271,
    rx: 7.06356,
    fill: "white",
    fillOpacity: 0.4
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 84.0403,
    y: 125.604,
    width: 119.939,
    height: 14.1271,
    rx: 7.06356,
    fill: "white",
    fillOpacity: 0.4
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 108.638,
    y: 203.18,
    width: 119.939,
    height: 14.1271,
    rx: 7.06356,
    fill: "white",
    fillOpacity: 0.4
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_1_7261)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 275.273,
    y: 99.0117,
    width: 42.7756,
    height: 42.3814,
    rx: 6.7099,
    fill: "url(#paint4_linear_1_7261)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M288.658 122.175C287.406 120.984 285.5 120.984 284.248 122.175C282.975 123.386 282.975 125.26 284.248 126.47L288.784 130.787C289.384 131.358 290.053 131.681 290.99 131.681C291.926 131.681 292.595 131.358 293.195 130.787L309.074 115.679C310.346 114.468 310.346 112.594 309.074 111.384C307.821 110.192 305.916 110.192 304.663 111.384L290.99 124.394L288.658 122.175ZM305.281 112.02L290.99 125.618L288.041 122.812C287.133 121.949 285.772 121.949 284.865 122.812C284.545 123.116 284.338 123.474 284.244 123.848C284.338 123.474 284.545 123.117 284.865 122.812C285.772 121.949 287.133 121.949 288.041 122.812L290.99 125.618L305.281 112.021C306.188 111.157 307.549 111.157 308.456 112.021C309.044 112.58 309.251 113.319 309.078 114.006C309.251 113.319 309.044 112.579 308.456 112.02C307.549 111.157 306.188 111.157 305.281 112.02Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    clipPath: "url(#clip0_1_7261)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M395.351 73.3621L545.85 73.3621C548.891 73.3621 551.356 75.8272 551.356 78.8681L551.356 275.251",
    stroke: "white",
    strokeOpacity: 0.7,
    strokeWidth: 5
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M395.35 82.5391L540.344 82.5391C541.357 82.5391 542.179 83.3608 542.179 84.3744L542.179 278.922",
    stroke: "white",
    strokeOpacity: 0.7,
    strokeWidth: 5
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M395.351 91.7156L531.167 91.7156C532.181 91.7156 533.002 92.5373 533.002 93.5509L533.002 278.004",
    stroke: "white",
    strokeOpacity: 0.7,
    strokeWidth: 5
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M395.351 100.893L521.99 100.893C523.004 100.893 523.826 101.714 523.826 102.728L523.826 280.757",
    stroke: "white",
    strokeOpacity: 0.7,
    strokeWidth: 5
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M395.351 110.069L512.814 110.069C513.827 110.069 514.649 110.891 514.649 111.904L514.649 280.757",
    stroke: "white",
    strokeOpacity: 0.7,
    strokeWidth: 5
  })))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_1_7261)"
  }, _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_d_1_7261)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M444.523 164.158C442.231 165.738 439.201 165.738 436.908 164.158L384.902 128.319C383.085 127.066 382 125.001 382 122.794V36.5822C382 33.7592 383.761 31.2598 386.481 30.5055C394.625 28.2477 413.564 24 440.791 24C468.002 24 486.849 28.2427 494.955 30.5016C497.669 31.2578 499.423 33.7532 499.423 36.5704V122.794C499.423 125.001 498.338 127.066 496.521 128.319L444.523 164.158Z",
    fill: "url(#paint5_linear_1_7261)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M440.038 98.2107C440.715 98.6121 441.528 98.6121 442.204 98.2107L475.781 77.6048C476.323 77.2034 476.729 76.5344 476.729 75.8654C476.729 75.1963 476.323 74.5273 475.781 74.1259L442.204 53.3863C441.528 52.9849 440.715 52.9849 440.038 53.3863L406.461 74.1259C405.92 74.3935 405.514 75.0625 405.514 75.8654C405.514 76.6682 405.92 77.2034 406.461 77.6048L440.038 98.2107ZM475.781 98.8795C473.789 97.6487 471.273 97.6447 469.276 98.8691L442.205 115.471C441.528 115.873 440.715 115.873 440.038 115.471L413.197 98.9363C411.137 97.6673 408.543 97.6454 406.462 98.8795C405.92 99.1471 405.514 99.8161 405.514 100.619C405.514 101.288 405.92 101.957 406.462 102.358L440.038 123.098C440.715 123.499 441.528 123.499 442.205 123.098L475.781 102.358C476.323 101.957 476.729 101.288 476.729 100.619C476.729 99.9499 476.323 99.2809 475.781 98.8795ZM442.205 103.027L469.276 86.4252C471.273 85.2007 473.789 85.2048 475.781 86.4356C476.323 86.837 476.729 87.506 476.729 88.175C476.729 88.8441 476.323 89.5131 475.781 89.9145L442.205 110.52C441.528 110.922 440.715 110.922 440.038 110.52L406.462 89.9145C405.92 89.5131 405.514 88.8441 405.514 88.175C405.514 87.506 405.92 86.837 406.462 86.4356C408.543 85.2015 411.137 85.2234 413.197 86.4924L440.038 103.027C440.715 103.429 441.528 103.429 442.205 103.027Z",
    fill: "url(#paint6_linear_1_7261)"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_d_1_7261)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 478,
    y: 260.36,
    width: 105.024,
    height: 62.3255,
    rx: 5.5562,
    fill: "url(#paint7_linear_1_7261)"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M521.405 276.54C522.844 276.54 524.225 277.106 525.242 278.114C526.26 279.123 526.832 280.49 526.832 281.916C526.832 284.264 525.33 286.253 523.214 286.988V298.351C525.33 299.085 526.832 301.075 526.832 303.423C526.832 304.849 526.26 306.216 525.242 307.224C524.225 308.233 522.844 308.799 521.405 308.799C519.966 308.799 518.586 308.233 517.568 307.224C516.55 306.216 515.979 304.849 515.979 303.423C515.979 301.075 517.48 299.085 519.596 298.351V286.988C517.48 286.253 515.979 284.264 515.979 281.916C515.979 280.49 516.55 279.123 517.568 278.114C518.586 277.106 519.966 276.54 521.405 276.54ZM521.405 280.124C520.925 280.124 520.465 280.313 520.126 280.649C519.787 280.985 519.596 281.441 519.596 281.916C519.596 282.391 519.787 282.847 520.126 283.183C520.465 283.52 520.925 283.708 521.405 283.708C521.885 283.708 522.345 283.52 522.684 283.183C523.024 282.847 523.214 282.391 523.214 281.916C523.214 281.441 523.024 280.985 522.684 280.649C522.345 280.313 521.885 280.124 521.405 280.124ZM521.405 301.63C520.925 301.63 520.465 301.819 520.126 302.155C519.787 302.491 519.596 302.947 519.596 303.423C519.596 303.898 519.787 304.354 520.126 304.69C520.465 305.026 520.925 305.215 521.405 305.215C521.885 305.215 522.345 305.026 522.684 304.69C523.024 304.354 523.214 303.898 523.214 303.423C523.214 302.947 523.024 302.491 522.684 302.155C522.345 301.819 521.885 301.63 521.405 301.63ZM548.538 303.423C548.538 304.849 547.967 306.216 546.949 307.224C545.931 308.233 544.551 308.799 543.112 308.799C541.672 308.799 540.292 308.233 539.274 307.224C538.257 306.216 537.685 304.849 537.685 303.423C537.685 301.075 539.186 299.085 541.303 298.351V283.708H537.685V289.533L529.997 281.916L537.685 274.299V280.124H541.303C542.262 280.124 543.182 280.502 543.861 281.174C544.539 281.846 544.921 282.758 544.921 283.708V298.351C547.037 299.085 548.538 301.075 548.538 303.423ZM543.112 301.63C542.632 301.63 542.172 301.819 541.833 302.155C541.493 302.491 541.303 302.947 541.303 303.423C541.303 303.898 541.493 304.354 541.833 304.69C542.172 305.026 542.632 305.215 543.112 305.215C543.591 305.215 544.052 305.026 544.391 304.69C544.73 304.354 544.921 303.898 544.921 303.423C544.921 302.947 544.73 302.491 544.391 302.155C544.052 301.819 543.591 301.63 543.112 301.63Z",
    fill: "white"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_d_1_7261)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 114,
    y: 243.472,
    width: 276.965,
    height: 62.6175,
    rx: 5.87116,
    fill: "url(#paint8_linear_1_7261)"
  }))), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 144.739,
    y: 258.318,
    width: 165.231,
    height: 14.1271,
    rx: 7.06356,
    fill: "white",
    fillOpacity: 0.4
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 144.739,
    y: 279.924,
    width: 119.939,
    height: 14.1271,
    rx: 7.06356,
    fill: "white",
    fillOpacity: 0.4
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_d_1_7261)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 335.971,
    y: 253.332,
    width: 42.7756,
    height: 42.3814,
    rx: 6.7099,
    fill: "url(#paint9_linear_1_7261)"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M361.133 266.154C361.133 264.105 359.459 262.473 357.358 262.473C355.258 262.473 353.584 264.105 353.584 266.154C353.584 269.209 354.902 275.251 356.041 278.897H358.676C359.78 275.251 361.133 269.209 361.133 266.154ZM360.955 283.792C360.955 281.848 359.317 280.251 357.323 280.251C355.258 280.251 353.62 281.848 353.62 283.792C353.62 285.772 355.258 287.403 357.323 287.403C359.317 287.403 360.955 285.772 360.955 283.792Z",
    fill: "white"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_b_1_7261)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M526.564 330.529H527.045C528.328 318.881 538.59 309.751 550.778 309.751C554.947 309.751 558.956 310.853 562.484 312.741C567.134 303.454 576.756 297 588.141 297C603.856 297 616.524 309.436 616.524 324.862C616.524 327.066 616.203 329.113 615.883 331.159C624.542 333.048 630.956 340.761 630.956 349.734C630.956 360.281 622.137 368.939 611.393 368.939L608.186 368.781H529.931L526.564 368.939C515.82 368.939 507 360.438 507 349.734C507 339.03 515.82 330.529 526.564 330.529Z",
    fill: "url(#paint10_linear_1_7261)"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter11_b_1_7261)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M150.206 316.105H149.587C147.938 301.129 134.744 289.392 119.077 289.392C113.717 289.392 108.563 290.809 104.027 293.237C98.0489 281.297 85.6797 273 71.0429 273C50.8399 273 34.5538 288.987 34.5538 308.82C34.5538 311.653 34.9661 314.284 35.3784 316.914C24.2461 319.343 16 329.259 16 340.794C16 354.353 27.3384 365.483 41.1507 365.483L45.2737 365.281H145.876L150.206 365.483C164.018 365.483 175.356 354.555 175.356 340.794C175.356 327.033 164.018 316.105 150.206 316.105Z",
    fill: "url(#paint11_linear_1_7261)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_7261",
    x: 29,
    y: 28,
    width: 589,
    height: 377,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 20
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.129412 0 0 0 0 0.129412 0 0 0 0 0.298039 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_7261"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_7261",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1_7261",
    x: 0.529411,
    y: 71.1027,
    width: 373.624,
    height: 155.559,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 27.8824
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 23.2353
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.185714 0 0 0 0 0.185714 0 0 0 0 0.412723 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_7261"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_7261",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_1_7261",
    x: 27.5294,
    y: 148.412,
    width: 373.624,
    height: 154.638,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 27.8824
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 23.2353
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.185714 0 0 0 0 0.185714 0 0 0 0 0.412723 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_7261"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_7261",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_1_7261",
    x: 296.29,
    y: 173.645,
    width: 56.1954,
    height: 55.8011,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.35495
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.35495
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.129412 0 0 0 0 0.129412 0 0 0 0 0.298039 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_7261"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_7261",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_1_7261",
    x: 268.563,
    y: 95.6568,
    width: 56.1954,
    height: 55.8011,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.35495
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.35495
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.129412 0 0 0 0 0.129412 0 0 0 0 0.298039 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_7261"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_7261",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_1_7261",
    x: 330.53,
    y: 0.412352,
    width: 220.363,
    height: 244.283,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 27.8824
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 25.735
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0686326 0 0 0 0 0.0686326 0 0 0 0 0.329436 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_7261"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_7261",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_d_1_7261",
    x: 368.059,
    y: 19.3529,
    width: 145.306,
    height: 169.225,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 9.29412
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.97059
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0823529 0 0 0 0 0.0823529 0 0 0 0 0.282353 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_7261"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_7261",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_d_1_7261",
    x: 431.529,
    y: 241.772,
    width: 197.965,
    height: 155.267,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 27.8824
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 23.2353
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0838993 0 0 0 0 0.0838993 0 0 0 0 0.283603 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_7261"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_7261",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_d_1_7261",
    x: 67.5294,
    y: 224.884,
    width: 369.906,
    height: 155.559,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 27.8824
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 23.2353
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.185714 0 0 0 0 0.185714 0 0 0 0 0.412723 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_7261"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_7261",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_d_1_7261",
    x: 329.261,
    y: 249.977,
    width: 56.1954,
    height: 55.8011,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.35495
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.35495
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.129412 0 0 0 0 0.129412 0 0 0 0 0.298039 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_7261"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_7261",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_b_1_7261",
    x: 487,
    y: 277,
    width: 163.956,
    height: 111.939,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1_7261"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1_7261",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_b_1_7261",
    x: -4,
    y: 253,
    width: 199.356,
    height: 132.483,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1_7261"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1_7261",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_7261",
    x1: 96.9989,
    y1: 355,
    x2: 228.452,
    y2: 188.189,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#145DEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#441C99"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_7261",
    x1: 47,
    y1: 89.6909,
    x2: 202.534,
    y2: 263.986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4BD6B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#168982"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_7261",
    x1: 74,
    y1: 167,
    x2: 226.973,
    y2: 340.984,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4BD6B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#168982"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1_7261",
    x1: 303,
    y1: 177,
    x2: 353.269,
    y2: 189.684,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4BD6B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#168982"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1_7261",
    x1: 275.273,
    y1: 99.0117,
    x2: 325.542,
    y2: 111.696,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4BD6B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#168982"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1_7261",
    x1: 382,
    y1: 24,
    x2: 523.726,
    y2: 136.039,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9043C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A26B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1_7261",
    x1: 415.795,
    y1: 53.0852,
    x2: 500.691,
    y2: 77.3063,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#145DEB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1_7261",
    x1: 478,
    y1: 260.36,
    x2: 534.841,
    y2: 352.431,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9043C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A26B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1_7261",
    x1: 390.965,
    y1: 306.09,
    x2: 345.77,
    y2: 167.753,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E555AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F99048"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1_7261",
    x1: 378.746,
    y1: 295.713,
    x2: 330.101,
    y2: 261.736,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E555AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F99048"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1_7261",
    x1: 605.96,
    y1: 295.693,
    x2: 536.497,
    y2: 400.929,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1.61469e-7,
    stopColor: "#D9DCFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9DCFA",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1_7261",
    x1: 48.1343,
    y1: 271.32,
    x2: 137.436,
    y2: 406.61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1.61469e-7,
    stopColor: "#D9DCFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9DCFA",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_7261"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 84,
    height: 206,
    fill: "white",
    transform: "translate(499.268 70)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCode2);
export default __webpack_public_path__ + "static/media/code2.150688ba47307f55f5d3b49be6376f10.svg";
export { ForwardRef as ReactComponent };